import { Locale } from '../types';

export const getDefaultLocaleObj = (existingLocaleObj: Locale[], locale: string) =>
  existingLocaleObj.find((item: Locale) => item?.fields?.file?.fileName.includes(locale));
